import React, { ReactNode, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

interface ParallaxSectionProps {
  children: ReactNode;
  speed?: number; // Positive values scroll slower, negative values scroll faster
  className?: string;
  offsetStart?: number; // Value between 0 and 1
  offsetEnd?: number; // Value between 0 and 1
}

const ParallaxSection: React.FC<ParallaxSectionProps> = ({
  children,
  speed = 0.5,
  className = '',
  offsetStart = 0,
  offsetEnd = 1
}) => {
  const ref = useRef<HTMLDivElement>(null);
  
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: [offsetStart, offsetEnd]
  });
  
  // Calculate the y-position based on scroll progress and speed
  const y = useTransform(scrollYProgress, [0, 1], [0, 100 * speed]);
  
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.div
        style={{ y }}
        className="relative w-full h-full"
      >
        {children}
      </motion.div>
    </div>
  );
};

export default ParallaxSection; 